import { EnvironmentProviders, Provider } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { combineReducers, provideState } from '@ngrx/store';
import { BoardSummaryReportEffects } from 'app/trello/store/board-summary-report/board-summary-report.effects';
import { boardSummaryReportReducer } from 'app/trello/store/board-summary-report/board-summary-report.reducer';
import { BoardSummaryReportState } from 'app/trello/store/board-summary-report/board-summary-report.state';

export interface MainState {
  boardSummaryReport: BoardSummaryReportState;
}

export const providers: Array<Provider | EnvironmentProviders> = [

  provideState(
    'main',
    combineReducers<MainState>({
      boardSummaryReport: boardSummaryReportReducer,
    })
  ),
  provideEffects([
    BoardSummaryReportEffects,
  ]),
];
